var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"canvasContainer",staticClass:"wordcloud-container"},[_c('canvas',{ref:"wordCanvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }